import { useEffect } from "react";
import Swal from "sweetalert2";
import { userStore } from "../../store/types";
import { order } from "../review/Review";
import { marketplaceCdn } from "../../utility/env";

export const useReviewNotification = (user: userStore, isLoading: boolean, orders: Array<order>, router: any) => {
    useEffect(() => {
        if (!user || isLoading || !orders || orders.length === 0) return;

        const alertShown = localStorage.getItem("reviewAlert");
        if (alertShown === "false") return;

        const showNotification = async (order: any) => {
            return Swal.fire({
                toast: true,
                position: "bottom-end",
                title: "Review Reminder",
                html: `
          <div style="display: flex; align-items: center; font-size: 13px; text-align: left;">
            <img src="${`${marketplaceCdn}/${order?.image}`}" alt="Product" style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px; margin-right: 10px;" />
            <div>
              <strong>📦 ${order.title}</strong><br>
              <small style="color: #666;">Order: ${order.orderNumber}</small><br>
              <small style="color: #007bff; cursor: pointer;">⭐ Click to write review</small>
            </div>
          </div>
        `,
                showConfirmButton: false,
                timer: 6000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("click", () => {
                        Swal.close();
                        router.push(`/review?order_id=${order.order_id}`);
                    });
                },
            });
        };

        const runNotifications = async () => {
            for (let order of orders.slice(0, 2)) {
                await showNotification(order);
            }
            localStorage.setItem("reviewAlert", "false");
        };

        runNotifications();
    }, [user, isLoading, orders, router]);
};
